export default {
  account: 'Account',
  contact: 'Contact',
  lead: 'Lead',
  opportunity: 'Opportunity',
  case: 'Case',
  chooseEntity: 'Please select entity type',
  create: 'Create',
} as const;
